export const ICON_TRANSLATIONS: Record<
  string,
  { label: string; keywords: string[] }
> = {
  BackwardPanel: { label: '后退', keywords: ['倒放', '返回', '回放', '媒体'] },
  BagPanel: { label: '购物袋', keywords: ['购物', '购买', '商店', '商品'] },
  BaseballPanel: { label: '棒球', keywords: ['运动', '比赛', '球类'] },
  BasketballPanel: { label: '篮球', keywords: ['运动', '比赛', '投篮'] },
  BitcoinPanel: {
    label: 'Bitcoin',
    keywords: ['比特币', '数字货币', '投资', '金融'],
  },
  BookPanel: { label: '书籍', keywords: ['阅读', '学习', '知识', '图书馆'] },
  CalendarPanel: { label: '日历', keywords: ['日期', '日程', '时间', '提醒'] },
  CameraPanel: { label: '相机', keywords: ['拍照', '摄影', '镜头', '记录'] },
  CardPanel: { label: '银行卡', keywords: ['信用卡', '支付', '金融', '交易'] },
  Cart2Panel: { label: '购物篮', keywords: ['购物', '购买', '商店', '商品'] },
  CartPanel: { label: '购物车', keywords: ['购物', '购买', '商店', '结算'] },
  CategoryPanel: { label: '分类', keywords: ['应用', '网格', '菜单', '布局'] },
  ChartPanel: { label: '图表', keywords: ['数据', '时间', '计时', '日程'] },
  ChatPanel: { label: '聊天', keywords: ['消息', '交流', '对话', '评论'] },
  ChemicalPanel: { label: '化学', keywords: ['实验', '科学', '技术', '研究'] },
  CirclePanel: { label: '圆形', keywords: ['目标', '中心', '标记', '形状'] },
  Cloudy2Panel: {
    label: '夜间多云',
    keywords: ['天气', '天空', '夜晚', '月亮'],
  },
  CloudyPanel: {
    label: '云朵',
    keywords: ['天气', '天空', '云端', '存储', '同步'],
  },
  CodePanel: { label: '代码', keywords: ['编程', '程序', '技术', '开发'] },
  CoinPanel: { label: '硬币', keywords: ['货币', '金钱', '金融', '支付'] },
  CollectPanel: { label: '收藏', keywords: ['书签', '标记', '保存', '标签'] },
  ColorPanel: { label: '颜色', keywords: ['色彩', '设计', '绘画', '调色'] },
  Computer2Panel: {
    label: '笔记本电脑',
    keywords: ['电脑', '设备', '办公', '屏幕'],
  },
  ComputerPanel: {
    label: '台式电脑',
    keywords: ['电脑', '设备', '显示器', '办公'],
  },
  ConfusePanel: { label: '困惑', keywords: ['疑问', '表情', '情绪', '疑惑'] },
  CubePanel: { label: '立方体', keywords: ['方块', '盒子', '几何', '形状'] },
  Data2Panel: {
    label: '数据图表',
    keywords: ['数据', '数据库', '服务器', '仪表盘'],
  },
  DataPanel: { label: '数据', keywords: ['数据库', '列表', '程序', '服务器'] },
  DirectionPanel: { label: '方向', keywords: ['箭头', '光标', '指针', '导航'] },
  DirectionSign2Panel: {
    label: '方向指示',
    keywords: ['方向', '箭头', '路线', '导航'],
  },
  DirectionSign3Panel: {
    label: '路线指示',
    keywords: ['方向', '箭头', '路线', '导航'],
  },
  DirectionSign4Panel: {
    label: '道路指示',
    keywords: ['方向', '箭头', '路线', '导航'],
  },
  DirectionSignPanel: {
    label: '路标',
    keywords: ['方向', '箭头', '路线', '导航'],
  },
  DiscordPanel: {
    label: 'Discord',
    keywords: ['聊天', '社区', '语音', '社交'],
  },
  Drink2Panel: { label: '饮品', keywords: ['饮料', '酒水', '杯子', '果汁'] },
  DrinkPanel: { label: '饮料', keywords: ['饮品', '酒水', '杯子', '果汁'] },
  EyePanel: { label: '眼睛', keywords: ['查看', '视力', '观察', '显示'] },
  FilePanel: { label: '文件', keywords: ['文档', '笔记', '页面', '报告'] },
  FirePanel: { label: '火焰', keywords: ['火苗', '燃烧', '温暖', '热量'] },
  Flag2Panel: { label: '旗帜', keywords: ['旗子', '标记', '信号', '国家'] },
  Flag3Panel: { label: '旗子', keywords: ['旗帜', '标记', '信号', '国家'] },
  FlagPanel: { label: '旗帜标记', keywords: ['旗子', '标记', '信号', '国家'] },
  FlashPanel: { label: '闪电', keywords: ['电力', '能量', '速度', '雷电'] },
  FlowerPanel: { label: '花朵', keywords: ['植物', '自然', '花园', '春天'] },
  Folder2Panel: {
    label: '新建文件夹',
    keywords: ['文件夹', '目录', '文件', '创建'],
  },
  Folder3Panel: {
    label: '收藏文件夹',
    keywords: ['文件夹', '目录', '文件', '收藏'],
  },
  FolderPanel: { label: '文件夹', keywords: ['目录', '文件', '存储', '整理'] },
  FoodPanel: { label: '食物', keywords: ['食品', '餐饮', '面条', '美食'] },
  ForwardPanel: { label: '前进', keywords: ['快进', '播放', '媒体', '视频'] },
  FruitPanel: { label: '水果', keywords: ['苹果', '食品', '健康', '营养'] },
  GamePanel: { label: '游戏', keywords: ['手柄', '娱乐', '游戏机', '控制器'] },
  GiftPanel: { label: '礼物', keywords: ['礼盒', '庆祝', '节日', '奖励'] },
  GithubPanel: { label: 'GitHub', keywords: ['代码', '仓库', '开发', '开源'] },
  GobletPanel: { label: '高脚杯', keywords: ['酒杯', '饮料', '饮品', '酒水'] },
  GooglePanel: {
    label: 'Google',
    keywords: ['谷歌', '搜索', '浏览器', '网络'],
  },
  GroupPanel: { label: '团队', keywords: ['成员', '朋友', '合作', '用户'] },
  HamburgerPanel: { label: '汉堡', keywords: ['快餐', '美食', '食品', '午餐'] },
  HappyPanel: { label: '开心', keywords: ['快乐', '表情', '微笑', '高兴'] },
  HeadphonePanel: { label: '耳机', keywords: ['音乐', '声音', '音频', '设备'] },
  HeartPanel: { label: '爱心', keywords: ['心形', '喜欢', '收藏', '爱情'] },
  HidePanel: {
    label: '隐藏',
    keywords: ['眼睛', '私密', '不可见', '关闭显示'],
  },
  HighHeelPanel: {
    label: '高跟鞋',
    keywords: ['鞋子', '时尚', '服饰', '女鞋'],
  },
  HomePanel: { label: '房屋', keywords: ['首页', '住宅', '建筑', '家庭'] },
  ImagePanel: { label: '图片', keywords: ['照片', '相册', '图库', '风景'] },
  InformationPanel: {
    label: '提示',
    keywords: ['警告', '信息', '注意', '问题'],
  },
  LeafPanel: { label: '叶子', keywords: ['植物', '自然', '绿色', '森林'] },
  LiftPanel: { label: '健身', keywords: ['哑铃', '锻炼', '运动', '训练'] },
  LightPanel: { label: '台灯', keywords: ['灯光', '照明', '阅读', '学习'] },
  LockPanel: { label: '锁具', keywords: ['安全', '隐私', '保护', '加密'] },
  LongSleevePanel: {
    label: '长袖',
    keywords: ['衣服', '衬衫', '服装', '服饰'],
  },
  MailboxPanel: { label: '邮箱', keywords: ['邮件', '信箱', '收纳', '包裹'] },
  MailPanel: { label: '邮件', keywords: ['信封', '消息', '通知', '发送'] },
  MapPanel: { label: '地图', keywords: ['位置', '地点', '导航', '路线'] },
  MathPanel: { label: '数学', keywords: ['计算', '算术', '公式', '计算器'] },
  MicPanel: { label: '麦克风', keywords: ['话筒', '音频', '录音', '语音'] },
  MoonPanel: { label: '月亮', keywords: ['夜晚', '天空', '睡眠', '月光'] },
  MountainPanel: { label: '山峰', keywords: ['山脉', '登山', '自然', '风景'] },
  MousePanel: { label: '鼠标', keywords: ['点击', '光标', '指针', '电脑'] },
  MoviePanel: { label: '电影', keywords: ['影片', '视频', '影院', '媒体'] },
  NightPanel: { label: '夜晚', keywords: ['月亮', '天空', '天气', '傍晚'] },
  PausePanel: { label: '暂停', keywords: ['播放', '音频', '视频', '等待'] },
  PeacePanel: { label: '平静', keywords: ['表情', '情绪', '安静', '平和'] },
  PersonPanel: { label: '人物', keywords: ['用户', '头像', '成员', '账号'] },
  PhonePanel: { label: '手机', keywords: ['设备', '通讯', '屏幕', '移动'] },
  PickerPanel: { label: '取色器', keywords: ['颜色', '滴管', '设计', '工具'] },
  PlanetPanel: { label: '地球', keywords: ['世界', '星球', '地图', '地理'] },
  PlayPanel: { label: '播放', keywords: ['音频', '视频', '媒体', '开始'] },
  Presentation2Panel: {
    label: '演示图表',
    keywords: ['演示', '会议', '报告', '统计'],
  },
  PresentationPanel: {
    label: '演示',
    keywords: ['会议', '图表', '报告', '展示'],
  },
  QrCodePanel: {
    label: '二维码',
    keywords: ['扫码', '条形码', '编码', '扫描'],
  },
  RainPanel: { label: '下雨', keywords: ['雨水', '天气', '雨伞', '降雨'] },
  RulerPanel: { label: '尺子', keywords: ['测量', '长度', '工具', '绘图'] },
  SadPanel: { label: '难过', keywords: ['伤心', '表情', '情绪', '失望'] },
  SettingsPanel: { label: '设置', keywords: ['配置', '齿轮', '调整', '选项'] },
  ShoesPanel: { label: '运动鞋', keywords: ['鞋子', '跑步', '健身', '运动'] },
  ShortPantsPanel: {
    label: '短裤',
    keywords: ['裤子', '衣服', '服装', '服饰'],
  },
  SignalPanel: { label: '信号', keywords: ['图表', '数据', '统计', '趋势'] },
  SkateboardPanel: {
    label: '滑板',
    keywords: ['运动', '娱乐', '滑行', '街头'],
  },
  SkirtPanel: { label: '裙子', keywords: ['衣服', '服装', '时尚', '服饰'] },
  SmilePanel: { label: '微笑', keywords: ['笑脸', '表情', '开心', '快乐'] },
  Snow2Panel: { label: '降雪', keywords: ['下雪', '天气', '冬天', '雪花'] },
  SnowMountainPanel: {
    label: '雪山',
    keywords: ['山峰', '登山', '自然', '风景'],
  },
  SnowPanel: { label: '雪花', keywords: ['冰雪', '冬天', '天气', '寒冷'] },
  SocketPanel: { label: '插座', keywords: ['电源', '充电', '电力', '插头'] },
  StarPanel: { label: '星星', keywords: ['收藏', '星标', '评分', '奖励'] },
  SuitcasePanel: {
    label: '行李箱',
    keywords: ['旅行', '行李', '旅游', '假期'],
  },
  SunglassPanel: {
    label: '太阳镜',
    keywords: ['眼镜', '墨镜', '时尚', '配饰'],
  },
  SunPanel: { label: '太阳', keywords: ['阳光', '天气', '光线', '自然'] },
  TagPanel: { label: '标签', keywords: ['分类', '标记', '书签', '价格'] },
  TimePanel: { label: '时间', keywords: ['时钟', '闹钟', '计时', '日程'] },
  TreePanel: { label: '树木', keywords: ['森林', '植物', '自然', '树林'] },
  TriangleRulerPanel: {
    label: '三角尺',
    keywords: ['尺子', '测量', '几何', '绘图'],
  },
  TShirtPanel: { label: '短袖', keywords: ['衣服', '服装', '服饰', '上衣'] },
  UmbrellaPanel: { label: '雨伞', keywords: ['雨水', '天气', '保护', '遮阳'] },
  UsbPanel: {
    label: 'USB 设备',
    keywords: ['存储', '传输', '闪存', '移动设备'],
  },
  VolumePanel: { label: '音量', keywords: ['声音', '扬声器', '音频', '播放'] },
  WalletPanel: { label: '钱包', keywords: ['现金', '金钱', '支付', '金融'] },
  WindmillPanel: { label: '风车', keywords: ['风力', '能源', '发电', '旋转'] },
  WindowPanel: { label: '窗口', keywords: ['浏览器', '屏幕', '桌面', '应用'] },
  YoutubePanel: {
    label: 'YouTube',
    keywords: ['视频', '影片', '媒体', '频道'],
  },
};
